<!-- <div class="navbar fixed-top transparent-header">
    <div class="container">
        <div class="row">
            <div class="col-6">
                <a class="navbar-brand" href="index.htm"><span class="lrgTxt">M</span>oney<span
                        class="lrgTxt">M</span>arket<span class="thin">.mx</span></a>
            </div>
            <div class="col-6 right">
                <img src="assets/images/secure-top.png" class="secureTop" />
            </div>
        </div>
    </div>
</div> -->


<div class="navbar navbar-expand-lg fixed-top transparent-header">

    <a class="navbar-brand pl-5">
        <!-- <span class="lrgTxt">M</span>oney<span class="lrgTxt">M</span>arket<span class="thin">.mx</span> -->
        <img class="logo-img-color" style="display: none;" src="https://o7-assets.s3.amazonaws.com/money_market/images/moneymarket-color.png" width="70%" alt="moneymarket-logo"/>
        <img class="logo-img-white" src="https://o7-assets.s3.amazonaws.com/money_market/images/moneymarket-blanco.png" width="70%" alt="moneymarket-logo"/>
    </a>


    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
        </ul>
        <div class="my-2 my-lg-0 pr-5">
            <img src="assets/images/secure-top.png" class="secureTop" alt="seguridad_del_sitio" />
        </div>
    </div>
</div>